import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';

interface ActivitiesCompletedTimeSpentChartProps {
  activitiesCompletedSeries: number[];
  timeSpentSeries: number[];
  labels: string[];
  onClick?: (index: number) => void;
}

const ActivitiesCompletedTimeSpentChart: React.FC<ActivitiesCompletedTimeSpentChartProps> = ({
  activitiesCompletedSeries,
  timeSpentSeries,
  labels,
  onClick
}) => {
  const { fullChartWidth } = useContext(PrintViewContext);

  return (
    <BarChart
      height={250}
      width={fullChartWidth}
      onClick={onClick}
      series={[
        {
          name: 'Activities',
          data: activitiesCompletedSeries
        },
        {
          name: 'Time Spent',
          data: timeSpentSeries
        }
      ]}
      options={{
        colors: ['#0F6DB8', '#F4A527'],
        yaxis: [
          {
            decimalsInFloat: 0,
            title: {
              offsetX: -2,
              text: 'No of Activities',
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          },
          {
            opposite: true,
            decimalsInFloat: 0,
            title: {
              offsetX: 2,
              text: 'Minutes',
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          }
        ],
        xaxis: {
          categories: labels,
          labels: {
            offsetY: -4,
            style: {
              colors: '#373D3F',
              fontSize: '10px',
              fontFamily: 'futura-pt'
            }
          },
          axisTicks: { show: false }
        },
        legend: {
          offsetY: 2,
          horizontalAlign: 'left'
        },
        dataLabels: { enabled: false }
      }}
    />
  );
};

export default React.memo(ActivitiesCompletedTimeSpentChart);
